import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TagInputModule } from 'ngx-chips-4x';
import { Ng2SmartTableModule } from 'ng2-smart-table';

import { BrokersRoutingModule } from './brokers-routing.module';
import { BrokerFilterComponent } from './components/scripts/brokerFilter.component';
import { BrokerService } from './services/broker.service';
import { BrokerComponent } from './components/scripts/broker.component';
import { CountryService } from './services/country.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    BrokersRoutingModule,
    TagInputModule,
    Ng2SmartTableModule,
  ],
  declarations: [
    BrokerFilterComponent,
    BrokerComponent,
  ],
  providers: [
    BrokerService,
    CountryService,
  ]
})

export class BrokersModule { }



// WEBPACK FOOTER //
// ./src/app/brokers/brokers.module.ts